import { Card, CardActions, CardContent, Chip, Stack } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import React, { useEffect, useState } from "react";
import IntentScriptInputObject from "./IntentScriptInputObject";
import Controls from "../../../../components/form/controls/Controls";
import { uuid } from "../../../../utils/helper";
import { getTTSDefaultContext } from "../../../../apis/TTS/context.api";

const defaultSlotValue = {
  name: "value",
  type: "string",
};

const typeOption = [
  {
    id: "string",
    name: "String",
  },
  {
    id: "number",
    name: "Number",
  },
  {
    id: "object",
    name: "Object",
  },
  {
    id: "other",
    name: "Other",
  },
];

const formatPropSubmit = (props) => {
  const result = {};
  for (const prop of props) {
    const { name, value } = prop;
    result[name] = value;
  }
  return result;
};

const renderObjectSlotValue = (listSlot) => {
  const objValue = {};
  for (const slot of listSlot) {
    objValue[slot.name] = "";
  }
  return objValue;
};

const extractFields = (intentValue, listSlot) => {
  return listSlot.reduce((result, slot) => {
    if (intentValue.hasOwnProperty(slot)) {
      result[slot] = intentValue[slot];
    }
    return result;
  }, {});
};

const formatDataSubmit = (intentValues, listSlot) => {
  const listIntentSubmit = [];
  for (const intentValue of intentValues) {
    listIntentSubmit.push(
      extractFields(intentValue, [...listSlot, "fakeId", "type"])
    );
  }

  return listIntentSubmit;
};

const IntentScriptForm = ({
  availableSlotsContext,
  availableSlotNames,
  slotMapByName,
  recordForEdit,
  setRecordForEdit,
  inputPattern,
  setInputPattern,
  intentScriptValues,
  handleCreateIntentScript,
  type,
  setType,
}) => {
  const [currentInput, setCurrentInput] = useState({ name: "" });
  const [isReRenderProp, setIsReRenderProp] = useState(uuid());
  const [defaultContext, setDefaultContext] = useState({});

  useEffect(() => {
    getTTSDefaultContext({}, (result) => {
      setDefaultContext({ ...result });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderSlotsPicked = () => {
    if (!defaultContext?.slots) {
      return [...availableSlotsContext];
    } else {
      return [...(defaultContext?.slots || []), ...availableSlotsContext];
    }
  };

  const handleFocusInput = (e) => {
    const { name } = e.target;
    setCurrentInput({
      ...currentInput,
      name,
    });
  };

  const handleInputPatternChange = (e) => {
    const { name, value } = e.target;
    setInputPattern({
      ...inputPattern,
      [name]: value,
    });
  };

  const handleCopySlot = (slotName) => {
    const { name } = currentInput;
    let textValue = `${inputPattern[name]}, {${slotName}}`;
    if (!inputPattern[name]) {
      textValue = `{${slotName}}`;
    }
    setInputPattern({
      ...inputPattern,
      [name]: textValue,
    });
  };

  const handlePropsChange = (slotName, props) => {
    setInputPattern({
      ...inputPattern,
      [slotName]: formatPropSubmit(props),
    });
  };

  const submitValues = (action, fakeId) => {
    const newIntentScriptValues = [...intentScriptValues];
    if (action === "add") {
      const newValue = { ...inputPattern, fakeId: uuid(), type };
      newIntentScriptValues.push(newValue);
    } else {
      let recordIndex = intentScriptValues.findIndex(
        (value) => value.fakeId === fakeId
      );

      newIntentScriptValues[recordIndex] = {
        ...inputPattern,
        fakeId: uuid(),
        type,
      };
    }
    let listIntentSubmitFormat = formatDataSubmit(
      newIntentScriptValues,
      availableSlotNames
    );

    handleCreateIntentScript(listIntentSubmitFormat);

    let objectValuePattern = renderObjectSlotValue([
      defaultSlotValue,
      ...availableSlotsContext,
    ]);
    setInputPattern({ fakeId: "", ...objectValuePattern });
    setIsReRenderProp(uuid());
    setRecordForEdit(null);
  };

  return (
    <Card sx={{ marginTop: "25px" }}>
      <CardContent>
        <div style={{ marginBottom: "20px", display: "flex" }}>
          <h3 style={{ marginRight: "10px" }}>Slot:</h3>
          <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
            {renderSlotsPicked().map((slot, index) => (
              <Chip
                key={index}
                label={slot.name}
                color="info"
                disabled={false}
                size="small"
                variant="filled"
                icon={<ContentCopyIcon />}
                onClick={() => handleCopySlot(slot.name)}
              />
            ))}{" "}
          </Stack>
        </div>
        <Controls.Select
          name="type"
          label="Type"
          value={type}
          onChange={(e) => setType(e.target.value)}
          options={typeOption}
        />
        {availableSlotNames.map((slotName, index) => {
          if (slotMapByName[slotName]?.["type"] === "object") {
            return (
              <IntentScriptInputObject
                key={index}
                isReRenderProp={isReRenderProp}
                slot={slotMapByName[slotName]}
                handlePropsChange={handlePropsChange}
                recordForEdit={recordForEdit}
              />
            );
          } else {
            return (
              <Controls.Input
                key={index}
                name={slotName}
                value={inputPattern[slotName] || ""}
                label={slotName}
                type="text"
                style={{ marginRight: "10px" }}
                onChange={handleInputPatternChange}
                onFocus={handleFocusInput}
                default=""
              />
            );
          }
        })}
      </CardContent>
      <CardActions sx={{ display: "flex", justifyContent: "end" }}>
        <Controls.Button
          variant="outlined"
          text="Add new"
          color="primary"
          onClick={() => submitValues("add")}
        />

        {recordForEdit ? (
          <Controls.Button
            variant="outlined"
            text="Edit"
            color="warning"
            onClick={() => submitValues("edit", inputPattern["fakeId"])}
          />
        ) : null}
      </CardActions>
    </Card>
  );
};

export default IntentScriptForm;
